import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import CompanyOverview from "../pages/company-overview/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/company-overview",
    element: <CompanyOverview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
